import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CorporateCharterCompanyStatus } from '@interfaces/corporate-charter/responses/corporate-charter.response';

/**
 * Selo da situação do contrato social de uma empresa (Vigente, Lendo, "Com pendência N", "Contrato no Data Room, não
 * lido" ou "Sem contrato no Data Room"). Usado na lista Societário e no seletor de empresa do caminho da tela da empresa, para os dois falarem igual.
 */
@Component({
  selector: 'app-charter-status-badge',
  template: `
    @switch (status()) {
      @case ('current') {
        <span class="badge badge--current">
          <i class="pi pi-check-circle" aria-hidden="true"></i>Vigente
        </span>
      }
      @case ('reading') {
        <span class="badge badge--reading">
          <i class="pi pi-sync" aria-hidden="true"></i>Lendo
        </span>
      }
      @case ('pending') {
        <span
          class="badge badge--pending"
          title="Há documento na pasta de contrato social que o Cog ainda não leu">
          <i class="pi pi-inbox" aria-hidden="true"></i>Contrato no Data Room, não lido
        </span>
      }
      @case ('review') {
        <span class="badge badge--review">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>Com pendência
          {{ pendingReviewCount() }}
        </span>
      }
      @default {
        <span class="badge badge--none">Sem contrato no Data Room</span>
      }
    }
  `,
  styleUrl: './charter-status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharterStatusBadgeComponent {
  readonly status = input.required<CorporateCharterCompanyStatus>();
  readonly pendingReviewCount = input<number>(0);
}
